import Button from "./Button/Button";
import InputField from "./InputField/InputField";
import Checkbox from "./Checkbox/Checkbox";
import OtpInputField from "./OtpInputField/OtpInputField";
import PasswordInputField from "./PasswordInputField/PasswordInputField";
import PhoneNumberInputField from "./PhoneNumberInputField/PhoneNumberInputField";
import SelectField from "./SelectField/SelectField";
import SearchField from "./SearchField/SearchField";
import CampaignSearchField from "./CampaignSearchField/CampaignSearchField";
import TextArea from "./TextArea/TextArea";
import TimeInput from "./TimeInput/TimeInput";
import DateInput from "./DateInput/DateInput";
import RadioInput from "./RadioInput/RadioInput";
import ImageInputField from "./ImageInputField/ImageInputField";
import RadioButton from "./RadioButton/RadioButton";
import BoxedRadioInput from "./BoxedRadioInput/BoxedRadioInput";
import FileInput from "./FileInput/FileInput";
import Switch from "./Switch/Switch";
import MultipleSelectField from "./MultipleSelectField/MultipleSelectField";
import DateRangeInput from "./DateRangeInput";
import TagsMultiSelect from "./TagsMultiSelect/TagsMultiSelect";
import StockUnitInput from "./StockUnitInput/StockUnitInput";
import UrlInputField from "./UrlInputField/UrlInputFIeld";
import PercentageInputField from "./PercentageInputField/PercentageInputField";
import SlugInputField from "./SlugInputField/SlugInputField";
import CurrencyInputField from "./CurrencyInputField/CurrencyInputField";
import PointsInputField from "./PointsInputField/PointsInputField";
import DaysInputField from "./DaysInputField/DaysInputField";
import CartInputField from "./CartInputField";
import OrderComboBox from "./OrderComboBox";
import ProductComboBox from "./ProductComboBox";
import AmountField from "./AmountField";
import InputFieldV2 from "./InputFieldV2";
import SelectFieldV2 from "./SelectFieldV2";
import AmountFieldV2 from "./AmountFieldV2";
import TextAreaV2 from "./TextAreaV2";
import DateInputV2 from "./DateInputV2";
import MultipleSelectFieldV2 from "./MultipleSelectFieldV2";
import PhoneNumberInputFieldV2 from "./PhoneNumberInputFieldV2";
import HorizontalDivider from "./HorizontalDivider";
import TimeInputV2 from "./TimeInputV2";
import PercentField from "./PercentField";
import PercentFieldV2 from "./PercentFieldV2";
import MeasurementInputField from "./MeasurementInputField";
import ArrowButton from "./ArrowButton";
import ItemsInputField from "./ItemsInputField";
import EstimatedInput from "./EstimatedInput";
import FancySelectField from "./FancySelectField";
import PercentageInputFieldV2 from "./PercentageInputFieldV2";
import RadioButtonV2 from "./RadioButtonV2";

export * from "./ModalCloseBtn";

const primaryComponents = {
  Button: Button,
  InputField: InputField,
  Checkbox: Checkbox,
  OtpInputField: OtpInputField,
  PasswordInputField: PasswordInputField,
  PhoneNumberInputField: PhoneNumberInputField,
  SelectField: SelectField,
  SearchField: SearchField,
  CampaignSearchField: CampaignSearchField,
  TextArea: TextArea,
  TimeInput: TimeInput,
  DateInput: DateInput,
  RadioInput: RadioInput,
  ImageInputField: ImageInputField,
  RadioButton: RadioButton,
  BoxedRadioInput: BoxedRadioInput,
  FileInput: FileInput,
  Switch: Switch,
  MultipleSelectField: MultipleSelectField,
  DateRangeInput,
  TagsMultiSelect,
  StockUnitInput,
  UrlInputField,
  PercentageInputField,
  SlugInputField,
  CurrencyInputField,
  PointsInputField,
  DaysInputField,
  CartInputField,
  OrderComboBox,
  ProductComboBox,
  AmountField,
  InputFieldV2,
  SelectFieldV2,
  AmountFieldV2,
  DateInputV2,
  TextAreaV2,
  MultipleSelectFieldV2,
  PhoneNumberInputFieldV2,
  HorizontalDivider,
  TimeInputV2,
  PercentField,
  PercentFieldV2,
  MeasurementInputField,
  ArrowButton,
  ItemsInputField,
  EstimatedInput,
  FancySelectField,
  PercentageInputFieldV2,
  RadioButtonV2,
};

export default primaryComponents;
